/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

*,
:host {
  box-sizing: border-box;
  font-size: 1rem;
  font-family: inherit;
}

:host button,
:host input,
:host optgroup,
:host select,
:host textarea {
  font-family: inherit;
}

:host {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;
}
:host .status {
  order: 0;
  flex: 0 0 auto;
  align-self: center;
  overflow: hidden;
  height: 1.7142857143rem;
  width: 1.7142857143rem;
  margin-right: 0.5714285714rem;
}
:host .status davinci-icon,
:host .status davinci-icon-ref,
:host .status davinci-spinner {
  font-size: 1rem;
}
:host .text {
  flex: 1 1 auto;
  font-size: inherit;
  line-height: 1.7142857143rem;
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
}

:host([value=success]) .status > davinci-icon {
  fill: #63b017;
  fill: var(--davinci-color-success, #63b017);
}

:host([value=error]) .status > davinci-icon {
  fill: #EA0823;
  fill: var(--davinci-color-error, #EA0823);
}

:host([hidden]) {
  display: none;
}`;
export { style };
